<kw-wrapper class="bg-layer" [wrapperClass]="wrapperClass">
    <kw-title-renderer class="section-title" [title]="title"></kw-title-renderer>
    <div class="layout-layer" [ngClass]="layoutClass">
        <kw-grid-cell-wrapper  class="grid-cell-container with-border" [attr.cell-id]="cell.cellId" *ngFor="let cell of cells; let i = index">
            <ng-container *ngIf="edit; else display">
                <ng-container *ngIf="cell.status === 'Initial Draft';else inProgress">
                    <ng-container *ngTemplateOutlet="content"></ng-container>
                </ng-container>
                <ng-template #inProgress>
                    <kw-edit-placeholder-renderer [gridCell]="cell" (createGridCellContent)="createContent($event)"></kw-edit-placeholder-renderer>
                </ng-template>
            </ng-container>
            <ng-template #display>
                <ng-container *ngTemplateOutlet="content"></ng-container>
            </ng-template>
            <ng-template #content>
                <div class="cell-bg-layer" [ngStyle]="{'background':''+bgColor+''}"></div>
                <ng-container [ngSwitch]="fillClass">
                    <ng-container *ngSwitchDefault>
                        <div class="fill-layer" [ngClass]="fillClass" [style.--fillColor1]="fillColor1"></div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'class-5'">
                        <div class="fill-layer" [ngClass]="fillClass" [style.--fillColor1]="fillColor1">
                            <div class="svg-container">
                                <svg class="bottom-fill" id="visual" viewBox="0 0 960 540" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"><path d="M0 425L22.8 430.8C45.7 436.7 91.3 448.3 137 451C182.7 453.7 228.3 447.3 274 444.7C319.7 442 365.3 443 411.2 445.3C457 447.7 503 451.3 548.8 454.5C594.7 457.7 640.3 460.3 686 455.8C731.7 451.3 777.3 439.7 823 433.2C868.7 426.7 914.3 425.3 937.2 424.7L960 424L960 541L937.2 541C914.3 541 868.7 541 823 541C777.3 541 731.7 541 686 541C640.3 541 594.7 541 548.8 541C503 541 457 541 411.2 541C365.3 541 319.7 541 274 541C228.3 541 182.7 541 137 541C91.3 541 45.7 541 22.8 541L0 541Z" [attr.fill]="fillColor1" stroke-linecap="round" stroke-linejoin="miter"></path></svg>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'class-6'">
                        <div class="fill-layer" [ngClass]="fillClass" [style.--fillColor1]="fillColor1">
                            <div class="svg-container">
                                <svg class="top-fill" id="visual" viewBox="0 0 960 540" width="960" height="540" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"><path d="M0 113L22.8 107.2C45.7 101.3 91.3 89.7 137 87C182.7 84.3 228.3 90.7 274 93.3C319.7 96 365.3 95 411.2 92.7C457 90.3 503 86.7 548.8 83.5C594.7 80.3 640.3 77.7 686 82.2C731.7 86.7 777.3 98.3 823 104.8C868.7 111.3 914.3 112.7 937.2 113.3L960 114L960 0L937.2 0C914.3 0 868.7 0 823 0C777.3 0 731.7 0 686 0C640.3 0 594.7 0 548.8 0C503 0 457 0 411.2 0C365.3 0 319.7 0 274 0C228.3 0 182.7 0 137 0C91.3 0 45.7 0 22.8 0L0 0Z" [attr.fill]="fillColor1" stroke-linecap="round" stroke-linejoin="miter"></path></svg>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'class-7'">
                        <div class="fill-layer" [ngClass]="fillClass" [style.--fillColor1]="fillColor1">
                            <div class="curve-container-bottom">
                                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                                    <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" [attr.fill]="fillColor1" class="shape-fill"></path>
                                </svg>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngSwitchCase="'class-8'">
                        <div class="fill-layer" [ngClass]="fillClass" [style.--fillColor1]="fillColor1">
                            <div class="curve-container-top">
                                <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                                    <path d="M0,0V7.23C0,65.52,268.63,112.77,600,112.77S1200,65.52,1200,7.23V0Z" [attr.fill]="fillColor1" class="shape-fill"></path>
                                </svg>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>
                <div class="cell-content-layer" [style.--bg-image]="bgImgSrc">
                    <div class="content-layout" [ngClass]="cell.layoutClass">
                        <div *ngFor="let contentElement of cell.contentElements" [ngClass]="contentElement.containerClasses" [ngStyle]="{'background':''+contentElement?.containerBackground+''}">
                            <kw-content-element-renderer [contentElement]="contentElement" [preview]="preview" (updatedContent)="onUpdateContent($event)"></kw-content-element-renderer>
                        </div>
                    </div>
                </div>
            </ng-template>
        </kw-grid-cell-wrapper>
    </div>
</kw-wrapper>


<!-- <kw-wrapper>
    <ng-container [ngSwitch]="layout">
        <div *ngSwitchCase="'horizontal'" class="blog-list-grid-wrapper full content" [@animateText]="animateStart">
            <div *ngFor="let blogSummary of blogSummaries;  let i = index" class="blog-listing-wrapper cell-shadow">
                <div class="title">
                    <div class="heading">{{blogSummary?.heading}}</div>
                    <div class="byline">{{blogSummary?.author}}</div>
                </div>
                <div class="image-wrapper">
                    <img src="{{blogSummary?.imgSrc}}" class="card-img-top" alt="Hollywood Sign on The Hill" />
                </div>
                <div class="summary">
                    <div class="summary-text" @zoomIn>{{blogSummary?.summary}}</div>
                    <div class="details">
                        <div class="p-date">{{blogSummary?.date}}</div>
                        <div class="more-link">
                            <button nbButton status="primary" size="tiny">Read More</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngSwitchCase="'vertical'" class="blog-list-grid-wrapper vertical">
            <div *ngFor="let blogSummary of blogSummaries;  let i = index" class="blog-listing-wrapper-contained">
                <div class="image-wrapper">
                    <img src="{{blogSummary?.imgSrc}}" class="card-img-top" alt="Hollywood Sign on The Hill" />
                </div>
                <div class="blog-meta-data">
                    <div class="title">
                        <div class="heading">{{blogSummary?.heading}}</div>
                        <div class="byline">{{blogSummary?.author}}</div>
                    </div>
                    
                    <div class="summary">
                        <div class="summary-text">{{blogSummary?.summary}}</div>
                        <div class="details">
                            <div class="p-date">{{blogSummary?.date}}</div>
                            <div class="more-link">
                                <button nbButton status="primary" size="tiny">Read More</button>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </ng-container>
</kw-wrapper> -->

<!-- <ng-container *ngIf="layout == 'horizontal'">
    <div class="blog-list-grid-wrapper full" [@animateText]="animateStart">
        <div *ngFor="let blogSummary of blogSummaries;  let i = index" class="blog-listing-wrapper">
            <div class="title">
                <div class="heading">{{blogSummary?.heading}}</div>
                <div class="byline">{{blogSummary?.author}}</div>
            </div>
            <div class="image-wrapper">
                <img src="{{blogSummary?.imgSrc}}" class="card-img-top" alt="Hollywood Sign on The Hill" />
            </div>
            <div class="summary">
                <div class="summary-text" @zoomIn>{{blogSummary?.summary}}</div>
                <div class="details">
                    <div class="p-date">{{blogSummary?.date}}</div>
                    <div class="more-link">
                        <button nbButton status="primary" size="tiny">Read More</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container> -->


